import axios from 'axios';
import type { RcmPasswordResetTokenRequestData } from '../types';

const requestToken = async (data: RcmPasswordResetTokenRequestData) => {
  await axios.post('/api/v2/password-reset/reset-email', data);
};

export default requestToken;
